// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { addToEndOfChain, addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateAccount } from "@insite/client-framework/Services/AccountService";
import {
    CallUpdateAccount,
    chain,
    GetCurrentAccount,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import xLoadingOverlay from "@conklin/App/Handlers/XNG/LoadingOverlay";

type HandlerType = typeof GetCurrentAccount;

export const XCallUpdateAccount: HandlerType = async props => {
    try {
        props.apiResult = await updateAccount(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            // XNG-Changes : Clear loading overlay when error is returned
            props.dispatch(xLoadingOverlay({ key: "remove", id: "save_current_account" }));
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", id: "save_current_account" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "remove", id: "save_current_account" }));
};

addToStartOfChain(chain, setIsLoading);
replaceInChain(chain, CallUpdateAccount, XCallUpdateAccount);
addToEndOfChain(chain, setLoadingCompleted);
